

export default class ToolTips{

  constructor() {

  }

  init(translator){
    //
    // get all tooltips
    // for each create event listener and set label
      //
    let tooltipTriggers = document.querySelectorAll(".hastooltip");
    tooltipTriggers.forEach((item, i) => {

      let id = item.id;
      let tooltipText = translator.getDynamicText(id+"-tooltip");

      // create the tooltip element
      let tooltip = document.createElement("div");
      tooltip.classList.add("tooltip");
      tooltip.innerText = tooltipText;
      tooltip.id = "tooltip-"+id;

      if( item.classList.contains("tooltiptopright") ){
        tooltip.classList.add("tooltip-top");
      }

      document.body.appendChild(tooltip);

      //item.setAttribute("data-tooltip",tooltipText);
      item.addEventListener('mouseover',function(e){
        // console.log("show tooltip ", tooltipText);
        let el = e.currentTarget;
        let tt = document.getElementById("tooltip-"+id);
        let bb = el.getBoundingClientRect();
        let bbtt = tt.getBoundingClientRect();

        if( el.classList.contains("tooltipbottomcenter") ){
          tt.style.left = (bb.left + bb.width/2 - bbtt.width/2) + "px";
          tt.style.top = (bb.top - bbtt.height - 12) + "px";
        }else if( el.classList.contains("tooltipbottomright") ){
          tt.style.left = (bb.left + bb.width/2 - bbtt.width/2) + "px";
          tt.style.top = (bb.top - bbtt.height - 12) + "px";
        }else if( el.classList.contains("tooltiptopright") ){
          tt.style.left = (bb.left + bb.width/2 - bbtt.width/2) + "px";
          tt.style.top = (bb.bottom) + "px";
        }else if( el.classList.contains("tooltipbottomleft") ){
          let left = (bb.left + bb.width/2 - bbtt.width/2);
          if( left < 0){
            left = 0;
          }
          tt.style.left = left + "px";

          tt.style.top = (bb.top - bbtt.height - 12) + "px";
        }


        tt.classList.add("show");
      });

      item.addEventListener('mouseout',function(){
        // console.log("show tooltip ", tooltipText);
        let tt = document.getElementById("tooltip-"+id);
        tt.classList.remove("show");
      });
    });

  }

};
